"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleCheckBox = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const __1 = require("..");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const CheckBoxWrapper = styled_components_1.default.div `
  position: relative;
`;
const CheckBoxLabel = styled_components_1.default.label `
  position: absolute;
  top: 0;
  left: 0;
  width: 45px;
  height: 20px;
  border-radius: 12.5px;
  background: ${({ theme }) => theme.toggleSwitch.background.normal};
  box-shadow: ${({ theme }) => theme.toggleSwitch.boxShadows.top},
    ${({ theme }) => theme.toggleSwitch.boxShadows.bottom};
  cursor: pointer;
  transition: 0.2s;
`;
const CheckBox = styled_components_1.default.input `
  opacity: 0;
  z-index: 1;
  height: 20px;
  &:checked + ${CheckBoxLabel} {
    background: ${({ theme }) => theme.toggleSwitch.background.active};
  }
  &:focus + ${CheckBoxLabel} {
    outline: 0.5px solid #fffa;
    outline-offset: 1px;
  }
`;
/** Toggle switch component. Functionally a checkbox, but styled as a sliding switch.  */
const ToggleCheckBox = ({ checked, id, onChange, title, label, onFocus, onBlur, name, disabled, height, }) => {
    return (react_1.default.createElement(CheckBoxWrapper, { title: title },
        react_1.default.createElement(CheckBox, { type: "checkbox", checked: checked, id: id, onChange: onChange, "aria-label": `checkbox ${name}`, name: name, readOnly: true, disabled: disabled, height: height, onFocus: () => onFocus && onFocus(label), onBlur: () => onBlur && onBlur(), "data-testid": `checkbox-${id}` }),
        react_1.default.createElement(CheckBoxLabel, { htmlFor: id }),
        react_1.default.createElement(__1.ToggleSlider, { style: {
                position: "absolute",
                left: checked ? "25px" : "0px",
                pointerEvents: "none",
                top: 0,
                height: "21px",
                transition: "linear 0.2s",
            } })));
};
exports.ToggleCheckBox = ToggleCheckBox;
//# sourceMappingURL=ToggleCheckBox.js.map